import { Footer } from "./components/shell/Footer";
import { Header } from "./components/shell/Header";
import { WorkspaceShell } from "./features/workspace/WorkspaceShell";

export default function App() {
  return (
    <div className="app-shell">
      <Header />
      <WorkspaceShell />
      <Footer />
    </div>
  );
}
